import React from "react";
import "../../../css/DesignSystem/Inputs/NewTextArea.css";

const NewTextArea = ({
  id,
  label,
  value,
  onChange,
  placeholder,
  required = false,
  helperText,
  error,
  disabled = false,
  readOnly = false,
  maxLength = 300,
  className = "",
}) => {
  const count = value?.length || 0;

  return (
    <div className={`AnnouncementTextArea ${className}`.trim()}>
      {label && (
        <label
          htmlFor={id}
          className="AnnouncementTextArea__Label FP_Content text-black"
        >
          {label} {required && <span className="FP_Content_Semibold text-error">*</span>}
        </label>
      )}

      {helperText && (
        <p className="AnnouncementTextArea__Helper text-black">{helperText}</p>
      )}

      <div className="AnnouncementTextArea__Wrapper">
        <textarea
          id={id}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          readOnly={readOnly}
          maxLength={maxLength}
          className={`fp-form-input fp-form-textarea FP_Content announcement-content-textarea ${
            error ? "fp-form-input--error" : ""
          }`}
        />

        <span className="AnnouncementTextArea__Count FP_Help_Text ">
          {count}/{maxLength} characters
        </span>
      </div>

      {error && <p className="AnnouncementTextArea__Error">{error}</p>}
    </div>
  );
};

export default NewTextArea;
